export type ExternalServiceConfig = {
  /** 服务根地址；dev 环境留空时由 devProxy 代理，生产环境填完整 URL */
  baseUrl?: string;
  /** 统一路径前缀，例如 '' 或 '/api' */
  basePath: string;
  /** 请求超时（ms）；不传则不限制 */
  timeout?: number;
};

export const BizAppConfig = {
  // 应用名称
  appName: process.env.UMI_APP_APP_NAME,

  // 多语言应用名称
  appNames: {
    'zh-CN': process.env.UMI_APP_APP_NAME_ZH_CN,
    'zh-TW': process.env.UMI_APP_APP_NAME_ZH_TW,
    'en-US': process.env.UMI_APP_APP_NAME_EN_US,
    'ja-JP': process.env.UMI_APP_APP_NAME_JA_JP,
  },

  // 应用 logo
  appLogo: process.env.UMI_APP_APP_LOGO,

  // 底部版权
  appFooterCopyright: process.env.UMI_APP_APP_FOOTER_COPYRIGHT,

  // 多语言底部版权
  appFooterCopyrights: {
    'zh-CN': process.env.UMI_APP_APP_FOOTER_COPYRIGHT_ZH_CN,
    'zh-TW': process.env.UMI_APP_APP_FOOTER_COPYRIGHT_ZH_TW,
    'en-US': process.env.UMI_APP_APP_FOOTER_COPYRIGHT_EN_US,
    'ja-JP': process.env.UMI_APP_APP_FOOTER_COPYRIGHT_JA_JP,
  },

  // API 地址（由不同环境配置文件注入 UMI_APP_API_URL）
  appApiUrl: process.env.UMI_APP_API_URL,

  // 记录易 API 地址；未配置时参考资料页显示兜底提示
  appEasyRecordApiUrl: process.env.UMI_APP_EASY_RECORD_API_URL || '',

  // ============ 新建应用需要修改！！！ ============
  // SSO 客户端ID（优先读取环境变量，否则用默认值）
  appSsoClientId: process.env.UMI_APP_SSO_CLIENT_ID,

  // SSO 授权地址
  appSsoAuthorizeUrl: process.env.UMI_APP_SSO_AUTHORIZE_URL,

  // SSO 登出地址
  appSsoLogoutUrl: process.env.UMI_APP_SSO_LOGOUT_URL,

  // 个人中心地址
  appPersonalCenterUrl: process.env.UMI_APP_PERSONAL_CENTER_URL,

  // 企业管理地址
  // 支持占位符：{tenantUuid}、{organizationUuid}
  appTenantManagementUrl: process.env.UMI_APP_TENANT_MANAGEMENT_URL,

  // 工作台地址
  appWorkbenchUrl: process.env.UMI_APP_WORKBENCH_URL,

  // ─── 依赖外部服务 ─────────────────────────────────────────────────────────────
  // 参考：docs/harness/app/集成开发-添加依赖应用.md
  services: {
    /**
     * 智能 CRM 服务
     * dev：留空 → /bff/zy-crm/* 由 devProxy 代理到 UMI_APP_CRM_API_URL
     * prod：填入完整 CRM 服务地址，例如 https://crm-api.example.com
     */
    crm: {
      baseUrl: process.env.UMI_APP_CRM_API_URL || '',
      basePath: '',
    } as ExternalServiceConfig,
  },
};
